module.exports = __webpack_public_path__ + "img/ball.7ca2e681.svg";